// extracted by mini-css-extract-plugin
export var comment = "comment__L2sC";
export var tooltipDetails = "tooltip-details__Mb8A";
export var tooltipTitle = "tooltip-title__cbc3";